module.exports = __webpack_public_path__ + "img/gt.512b475b.svg";